<div fxLayout="column" fxLayoutAlign="center center" class="dialog-container c-primary-gray-900">
    <ui-kit-svg class="close-icon i-24 c-primary-gray-200" name="ic_cross" (click)="dialogRef.close()"/>
    <div class="h3-semi-bold">{{ 'i18n_af_incidentTransactionsDialogTitle' | translate }}</div>
    <div class="t3 mt-16">{{ 'i18n_af_incidentTransactionsDialogSubtitle' | translate }}</div>
    @if (dataSource.length) {
        <div class="table-wrapper mt-24">
            <af-table class="w-100"
                      [enableScroll]="false"
                      [enableSelection]="true"
                      [withoutBorder]="true"
                      [withHeaderBackground]="true"
                      height="medium"
                      [dataSource]="dataSource"/>
        </div>
    }
    <ui-kit-empty-state class="mt-24 w-100"
                        [spinnerIds]="'loadTransactions'"
                        [isSmall]="true"
                        [items]="dataSource"/>
    <ui-kit-button [label]="'i18n_af_buttonSave' | translate"
                   (clickListener)="dialogRef.close(selectedTransactions)"
                   [disabled]="!selectedTransactions.length"
                   class="mt-40"/>
</div>
